import { createContext, useEffect, useState } from "react"

export const AuthContext = createContext({})
export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const userToken = localStorage.getItem("user_token")
        // Sessão anterior à 4.0: o token não tem empresa_id e a API recusa as requisições.
        // A chave "empresa_id" sempre é gravada no login (vazia para o Super Admin).
        if (userToken && localStorage.getItem("empresa_id") === null) {
            localStorage.clear()
        } else if (userToken) {
            setUser(true)
        }
        setLoading(false)
    }, []);

    const signin = (data, result) => {

        if (result) {
            localStorage.setItem("user_token", JSON.stringify(data.token))
            localStorage.setItem("nome_completo", data.nome_completo)
            localStorage.setItem("foto", data.foto)
            localStorage.setItem("primeiro_login", data.primeiro_login)
            localStorage.setItem("nivel", data.nivel)
            localStorage.setItem("empresa_id", data.empresa_id ?? "")
            localStorage.setItem("concluiu_aula", data.concluiu_aula)
            setUser({
                ...data,
                concluiu_aula: data.concluiu_aula
            })
            return
        }

    };

    const signout = () => {
        setUser(null)
        localStorage.clear()
        return
    };

    return (
        <AuthContext.Provider
            value={{ user, signin, signout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};